import * as parser from "components/studio/Controller.lib.parser";
import * as board from "components/studio/Controller.lib.board";
import * as indexes from "components/studio/Controller.lib.index";


const saveBoard = (nodes, edges, flowId, activePage, isCasePreview, updateHistory, callAutoSave) => {
    if (isCasePreview) return;
    updateHistory(nodes, edges);
    const onlyNodes = nodes.filter((item) => item.isAnnotation == false);
    const onlyAnnotations = nodes.filter((item) => item.isAnnotation == true);

    const parsedNodes = parser.parseNodesUiToRequest(onlyNodes);
    const parsedEdges = parser.parseEdgesUiToRequest(edges);
    const parsedAnnotations = parser.parseAnnotationsUiToRequest(onlyAnnotations);

    callAutoSave({
        nodes: parsedNodes,
        edges: parsedEdges,
        annotations: parsedAnnotations,
        flow_id: flowId,
        page_id: activePage
    });
}

const saveNodePositions = (nodes, isCasePreview, callSaveUi) => {
    if (isCasePreview) return;
    const onlyNodes = nodes.filter((item) => item.isAnnotation == false);
    const onlyAnnotations = nodes.filter((item) => item.isAnnotation == true);

    const parsedNodes = parser.parseNodesUiToRequest(onlyNodes);
    const parsedAnnotations = parser.parseAnnotationsUiToRequest(onlyAnnotations);

    callSaveUi({
        nodes: parsedNodes,
        annotations: parsedAnnotations
    });

}

const onAutoSave = (data, selectedNodes, flowId, activePageId, isCasePreview, setNodes, setEdges, updateHistory, 
    onExecuteNode, onClickChangeTriggerStatus, onSelectNode, onDeleteNode, onClickInsertChild, callAutoSave) => {

	const dbNodes = data?.nodes ?? [];
	const dbEdges = data?.edges ?? [];
	const dbAnnotations = data?.annotations ?? [];

	const nodes = parser.parseNodesGraphqlToUi(dbNodes);
	const edges = parser.parseEdgesGraphqlToUi(dbEdges);
	const indexedNodes = indexes.assignIdxNodes(nodes, edges);
	const annotations = parser.parseAnnotationsGraphqlToUi(dbAnnotations);

	const newNodes = [], newAnnotations = [], newEdges = [];
	for (const node of indexedNodes) {
		const newNode = board.setNodeFunctions(node, onExecuteNode, onClickChangeTriggerStatus, onSelectNode, onDeleteNode, onClickInsertChild)
		newNode.data.is_selected = selectedNodes.includes(newNode.id);
		newNodes.push(newNode);
	}

	for (const edge of edges) {
		const newEdge = board.setEdgeFunctions(edge, flowId, activePageId, isCasePreview, updateHistory, callAutoSave);
		newEdges.push(newEdge);
	}

	for (const annotation of annotations) {
		const newAnnotation = board.setAnnotationFunctions(annotation, onSelectNode, onDeleteNode)
		newAnnotation.data.is_selected = selectedNodes.includes(annotation.id);
		newAnnotations.push(newAnnotation);
	}

	setNodes([...newNodes, ...newAnnotations]);
	setEdges(newEdges)
}


export { saveBoard, saveNodePositions, onAutoSave } 